const KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
];
const STORE_KEY = "pogo_attr";

export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  const merged = getAttribution();
  KEYS.forEach((k) => {
    const v = params.get(k);
    if (v && !merged[k]) merged[k] = v;
  });
  // Remember the first landing page + referrer of the session so the
  // Shopify cart can carry where the customer actually came from.
  if (!merged.landing_page) merged.landing_page = window.location.href;
  if (!merged.landing_referrer && document.referrer)
    merged.landing_referrer = document.referrer;
  try {
    sessionStorage.setItem(STORE_KEY, JSON.stringify(merged));
  } catch (e) {}
  return merged;
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}");
  } catch (e) {
    return {};
  }
}
